export default {
  performanceMetricNoDataAvailable: {
    id: 'PERFORMANCE_METRIC_NO_DATA_AVAILABLE',
    description: 'Performance metric no data available message',
    defaultMessage: 'Looks like there is currently no data available.',
  },
};
